import { Link } from '@tanstack/react-router';
import { Button, Card, CardBody, CardHeader, CardTitle, ReadOnlyValue } from '@/shared/components';
import { formatDate } from '@/shared/lib/format';
import type { CompanyResponse, UserResponse } from '@/shared/api';

interface Props {
  user: UserResponse;
  company: CompanyResponse | null;
  companyLoading: boolean;
  onEditName: () => void;
}

/**
 * Stammdaten — was zur Person gehört, nicht was sie darf.
 *
 * <p>Die E-Mail ist die Anmeldung und lässt sich über den bestehenden Vertrag nicht ändern;
 * sie steht deshalb als gesetzter Wert mit Kopieren-Aktion statt als scheinbar änderbares Feld.
 * Die Firmenzugehörigkeit wird beim Einladen gesetzt — es gibt keinen Endpunkt, sie später zu
 * wechseln, also behauptet die Fläche das auch nicht.</p>
 */
export function UserMasterDataCard({ user, company, companyLoading, onEditName }: Props) {
  return (
    <Card>
      <CardHeader className="justify-between">
        <CardTitle>Stammdaten</CardTitle>
        <Button
          variant="ghost"
          size="sm"
          className="border-line min-h-11 border"
          onClick={onEditName}
        >
          Namen bearbeiten
        </Button>
      </CardHeader>
      <CardBody>
        <dl className="divide-line/50 divide-y">
          <ReadOnlyValue label="Vorname" value={user.firstName || 'nicht hinterlegt'} />
          <ReadOnlyValue label="Nachname" value={user.lastName || 'nicht hinterlegt'} />
          <ReadOnlyValue
            label="E-Mail"
            value={user.email}
            copyable={user.email}
            hint="zugleich der Anmeldename"
          />
          <ReadOnlyValue
            label="Firma"
            value={
              companyLoading ? (
                'wird geladen…'
              ) : company ? (
                // Es gibt keine eigene Firmenseite; der Weg führt in die Firmenliste, und der
                // Titel sagt das auch, statt einen Sprung auf ein Detail zu versprechen.
                <Link
                  to="/companies"
                  title="Zur Firmenliste"
                  className="hover:text-sealwax underline underline-offset-4"
                >
                  {company.name}
                </Link>
              ) : (
                'nicht hinterlegt'
              )
            }
            hint={company ? 'erbt die Apartments der Firma' : undefined}
          />
          <ReadOnlyValue label="Angelegt am" value={formatDate(user.createdAt)} />
        </dl>
      </CardBody>
    </Card>
  );
}
